"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.Command = void 0; /**
 * Class representing a command to the Unified Login Component API
 */
class Command {




  /**
   * @param {string} clientType
   * @param {string} command
   * @param {object} commandDetails
   */
  constructor(clientType, command, commandDetails) {
    this.clientType = clientType;
    this.command = command;
    this.commandDetails = commandDetails;
  }

  static get Commands() {
    return {
      checkAuthentication: "check-authentication",
      changePassword: "change-password",
      initialize: "initialize",
      logout: "logout",
      logoutWarning: "logoutWarning",
      redeemCode: "redeem-code",
      refreshTokens: "refresh-tokens",
      startRegistration: "start-registration",
      updateProfile: "update-profile"
    };
  }

  static get CommandResponses() {
    return {
      initialized: "initialized-response",
      checkAuthentication: "check-authentication-response",
      changePassword: "change-password-response",
      logout: "logout-response",
      logoutWarning: "logout-warning-response",
      redeemCode: "redeem-code-response",
      refreshTokens: "refresh-tokens-response",
      navigateParent: "navigate-parent-response",
      redirectToLogin: "redirect-to-login-response",
      updateProfile: "update-profile-response"
    };
  }
}exports.Command = Command;